import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useRole } from '../context/RoleContext';
import { User, Settings as SettingsIcon } from 'lucide-react';
import ThemeToggle from './ThemeToggle';
import NotificationBell from './NotificationBell';

const Header = () => {
  const { user, profile } = useAuth();
  const { isAdmin, isOwner } = useRole();
  const navigate = useNavigate();

  // Prefer Firebase Auth user data, fallback to Firestore profile
  const displayName = user?.displayName || profile?.displayName || profile?.name || user?.email || profile?.email || 'User';
  const photoURL = user?.photoURL || profile?.photoURL;

  // Admins and owners go to full Settings; everyone else goes to their own Account page
  const settingsTarget = (isAdmin || isOwner) ? '/settings' : '/account';

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-6 py-3 flex items-center justify-between">
        {/* Left - App Title */}
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-semibold" style={{ color: 'var(--cb-navy)' }}>
            CleanBid<span style={{ color: '#116F73' }}>.ai</span>
          </h1>
        </div>

        {/* Right - Settings, User Info & Theme Toggle */}
        <div className="flex items-center gap-4">
          {/* Notification Bell */}
          <NotificationBell />

          {/* Settings Shortcut */}
          <button
            type="button"
            onClick={() => navigate(settingsTarget)}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors"
            title="Settings"
          >
            <SettingsIcon className="h-5 w-5 text-gray-600" />
          </button>

          {/* User Info */}
          {(user || profile) && (
            <div className="flex items-center gap-2 text-sm">
              {photoURL ? (
                <img
                  src={photoURL}
                  alt={displayName}
                  className="h-8 w-8 rounded-full object-cover border border-gray-200"
                />
              ) : (
                <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center border border-gray-200">
                  <User className="h-4 w-4" style={{ color: 'var(--cb-navy)' }} />
                </div>
              )}
              <span className="font-medium" style={{ color: 'var(--cb-dark)' }}>
                {displayName}
              </span>
            </div>
          )}

          {/* Theme Toggle */}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};

export default Header;
